"use client";

import React, { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import Link from "next/link";
import LinkCard from "@/components/LinkCard/LinkCard";
import Image from "next/image";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

interface SideNavProps {
  options: { value: string; to: string }[];
  children: React.ReactNode;
  currentPath: string;
}
const SideNav = ({ options, currentPath, children }: SideNavProps) => {
  const router = useRouter();
  const [activeOption, setActiveOption] = useState<string | undefined>(
    currentPath
  );
  useEffect(() => {
    const matchingOption = options.find((option) => option.to === currentPath);

    if (matchingOption) {
      setActiveOption(matchingOption.to);
    } else if (options.length > 0) {
      setActiveOption(options[0].to);
    }
  }, []);

  return (
    <div className="flex flex-col md:flex-row">
      <div className="w-full md:w-[280px]">
        <ul className="space-y-1 !pl-0 list-none">
          {options.map((option, index) => (
            <li
              key={index}
              className="border-r-transparent hover:border-r-2 hover:border-r-[#122377]"
            >
              <Link
                href={option.to}
                className={`block p-2 rounded-none transition-colors duration-200 !no-underline hover:!no-underline !text-[#196ecf] !text-base !font-medium ${
                  activeOption === option.to
                    ? "!bg-[#122377] !text-white !font-semibold border-r-2 border-r-[#ff5f0e]"
                    : "hover:!bg-[#c0e9ff]"
                }`}
                style={{ textDecoration: "none" }}
              >
                {option.value}
              </Link>
            </li>
          ))}
        </ul>
        <LinkCard
          to="/help/faq"
          title="Need more help?"
          linkText="Review FAQs"
          icon={faChevronRight}
        >
          <Image
            src="/Images/help-icon.png"
            alt="Help Icon"
            width={64}
            height={58}
            className="center-block program-icon"
          />
        </LinkCard>
      </div>
      <div className="w-full md:w-3/4 !pl-5">{children}</div>
    </div>
  );
};

export default React.memo(SideNav);
